/* eslint-disable */
export default {
  close: '閉じる',
} as const;

// @key: @#@"close"@#@ @source: @#@"Close"@#@
